import { t } from "i18next";
import { toast } from "react-toastify";
import useURL from "../hooks/useURL";

const handleAuthError = (error) => {
  const blockedI18nKey = error.response?.data?.i18nKey;
  const isBlockedUser =
    blockedI18nKey === "backend.user.login.error.user_blocked" ||
    blockedI18nKey === "backend.user.client.login.error.account_disabled" ||
    blockedI18nKey === "backend.user.client.login.error.account_blocked";

  const currentPath = window.location.pathname;
  const isAlreadyOnLoginPage =
    currentPath.includes("/login") || currentPath.includes(`/auth`);

  // Login forms show their own toast/alert; avoid duplicates on failed login
  if (isBlockedUser && !isAlreadyOnLoginPage) {
    toast.error(
      t(`${blockedI18nKey}.text`, {
        defaultValue:
          error.response?.data?.message || "Your account has been blocked.",
      }),
      { theme: "colored" }
    );
  }

  const shouldEndSession =
    error.response?.data?.status === 401 ||
    error.response?.data?.status === 403 ||
    (isBlockedUser && !isAlreadyOnLoginPage);

  if (shouldEndSession) {
    if (!isAlreadyOnLoginPage) {
      // Determine login page based on current path
      // Client routes typically include /site/ or /my/
      const { URLPrefix } = useURL();
      const isClientRoute =
        currentPath.includes("/site/") ||
        currentPath.includes("/my/") ||
        currentPath.includes("awtech.be");
      if (isClientRoute) {
        window.location.href = `${URLPrefix}auth/login`;
      } else {
        const returnTo = `${window.location.pathname}${window.location.search}`;
        window.location.href = `/login?redirect=${encodeURIComponent(returnTo)}`;
      }
    }

    setTimeout(() => {
      import("../stores/reduxStore").then(({ reduxStore }) => {
        import("intranet/features/users/usersSlice").then(
          ({ logoutEmployee, logoutClient }) => {
            const state = reduxStore.getState();
            const { user, client } = state.users;

            if (user) {
              reduxStore.dispatch(logoutEmployee());
            } else if (client) {
              reduxStore.dispatch(logoutClient());
            }
          }
        );
      });
    }, 100);
  }
};

export default handleAuthError;
